import React, { useState } from 'react'
import { Review, ReviewConnection } from '../../generated/nest-graphql'
import { __, concat, pipe, prop, take } from 'ramda'
import { mapIndexed } from '../../util/util'
import StarRatingComponent from 'react-star-rating-component'
import dayjs from 'dayjs'
import { Container } from '../Container'
import { Button } from '../Button'
import { GraySection } from '../GraySection'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faStar } from '@fortawesome/free-solid-svg-icons'

export const ReviewsList: React.FC<{ reviewConnection: ReviewConnection }> = ({ reviewConnection }) => {
  return (
    <GraySection>
      <Container>
        {
          pipe(
            prop('edges'),
            mapIndexed((review: Review, index) => {
              return (
                <div className="pb-4" key={index}>
                  <ReviewCard review={review} />
                </div>
              )
            })
          )(reviewConnection) as any
        }
      </Container>
    </GraySection>
  )
}

export const ReviewCard: React.FC<{ review: Review }> = ({ review }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const shouldBeExpandable = review.comment.length > 200
  const formatDate = dayjs(review.dateCreated).format('M/D/YYYY')
  const toggleExpansion = () => setIsExpanded(!isExpanded)
  return (
    <div
      className="flex flex-col p-5 h-100"
      style={{
        boxShadow: `0 3px 8px 0 rgba(0, 0, 0, 0.1)`,
        background: 'white',
      }}
    >
      <div>
        <p className="mb-0" style={{ fontFamily: 'IndustryInc-Base', fontSize: 12 }}>
          {review.reviewerName}
        </p>
        <StarRatingComponent
          name={'rating'}
          value={Number(review.rating)}
          editing={false}
          renderStarIconHalf={() => {
            return (
              <span>
                <FontAwesomeIcon icon={faStar} color="gold" />
              </span>
            )
          }}
          renderStarIcon={(index, value) => {
            return (
              <span>
                {index <= value ? (
                  <FontAwesomeIcon icon={faStar} color="gold" />
                ) : (
                  <FontAwesomeIcon icon={faStar} color="gold" />
                )}
              </span>
            )
          }}
        />
      </div>

      <div style={{ fontSize: 20, color: '#707070' }}>
        {shouldBeExpandable ? (
          <ExpandableText text={review.comment} isExpanded={isExpanded} toggleExpansion={toggleExpansion} />
        ) : (
          <p>{review.comment}</p>
        )}
      </div>
      <div className="mt-auto">
        <div className="flex flex-row justify-end">
          <div className="mr-2">
            <Pill color={`#707070`}>{formatDate}</Pill>
          </div>
          <Pill color={`#15d90e`}>
            <div className="flex flex-row items-center">
              <FontAwesomeIcon icon={faCheckCircle} color={'#14d90d'} />
              <span className="pl-1" style={{ fontFamily: 'IndustryInc-Base' }}>
                Verified
              </span>
            </div>
          </Pill>
        </div>
      </div>
    </div>
  )
}

export const ExpandableText: React.FC<{
  text: string
  toggleExpansion: () => void
  isExpanded: boolean
}> = ({ text, toggleExpansion, isExpanded }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const textToDisplay = isExpanded ? text : pipe(take(200), concat(__, '...'))(text)
  return (
    <p>
      <>
        {textToDisplay}
        <Button style={{ backgroundColor: '#d5d5d5' }} onClick={toggleExpansion}>
          {isExpanded ? '-' : '+'}
        </Button>
      </>
    </p>
  )
}

export const Pill: React.FC<{ color: string; children?: any }> = ({ color, children }) => {
  return (
    <div
      style={{
        borderRadius: 12,
        border: `solid .5px ${color}`,
        color,
        fontSize: 12,
        paddingLeft: 8,
        paddingRight: 8,
        fontFamily: 'IndustryInc-Base',
      }}
    >
      {children}
    </div>
  )
}
